import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "advertising-row" }
const _hoisted_2 = {
  key: 0,
  class: "advertising-carousel"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "juou-title" }, " 轮播 ", -1)
const _hoisted_4 = {
  key: 1,
  class: "advertising-distribute"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "juou-title" }, " 均匀分布 ", -1)
const _hoisted_6 = { class: "advertising-distribute-content" }
const _hoisted_7 = { class: "advertising-row-op" }

import { JuouProForm, JuouProFormItem, useBaseAsync, useBaseTenantStore, useBaseUserStore } from 'juou-managebase-ui';
import AdvertisingItem from './AdvertisingItem.vue';
import { useApi } from '@/hooks/useApi';
import { ref } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertisingRow',
  props: {
    rowData: {},
    isFirst: { type: Boolean },
    isLast: { type: Boolean }
  },
  emits: ['change'],
  setup(__props: any, { emit: __emit }) {

const loading = ref(false);

const props = __props;

const addDialogRef = ref<InstanceType<typeof JuouProForm>>();


const typeOp: {
    value: any;
    label: string;
}[] = [
  {
    label: '小程序',
    value: 'weapp',
  },
  {
    label: '公众号文章',
    value: 'wx',
  },
  {
    label: '插件',
    value: 'plugin',
  },
];

const items: JuouProFormItem[] = [
  {
    name: 'image',
    label: '图片',
    rule: [{ required: true }],
    type: 'image',
    action: useApi().uploadImageUrl,
    multiple: false,
    onSuccess(data) {
      console.log(data.data[0]);
      addDialogRef.value?.setOneFormState('image', data.data[0]);
    },
  },
  {
    type: 'select',
    label: '类型',
    name: 'type',
    options: typeOp,
    rule: [{ required: true }],
  },
  {
    type: 'string',
    label: 'URL/Path',
    name: 'url',
    rule: [{ required: true }],
  },
  {
    type: 'string',
    label: 'appid',
    name: 'appid',
  },
];

const datas = ref<any[]>([]);

const emits = __emit;

const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    const res = await useApi().advertisingApi.listAdvertisingadvertising({
      conditions: {
        rowId: props.rowData.id,
      },
    });
    if (res?.data?.data) {
      datas.value = res.data.data;
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
});


const moveRow = useBaseAsync(async(type: 'up' | 'down') => {
  try {
    loading.value = true;
    await useApi().advertisingApi.moveAdvertisingRowadvertising({
      advertisingRowId: props.rowData.id,
      up: type === 'up',
    });
    emits('change');
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
});

const delRow = useBaseAsync(() => {
  ElMessageBox.confirm('删除后无法恢复，确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
  }).then(async() => {
    try {
      loading.value = true;
      await useApi().advertisingApi.delAdvertisingRowadvertising(props.rowData.id);
      emits('change');
    } catch (error) {
      console.log(error);
    } finally {
      loading.value = false;
    }
  });
});

const handleAdd = useBaseAsync(async(data: any) => {
  try {
    await useApi().advertisingApi.addAdvertisingadvertising({
      advertisingAdminVo: {
        rowId: props.rowData.id,
        sequence: datas.value.length + 1,
        ...data,
      },
    });
    ElMessage.success('添加成功');
    addDialogRef.value?.reset();
    init();
  } catch (error) {
    console.log(error);
  }
});

init();



return (_ctx: any,_cache: any) => {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_Delete = _resolveComponent("Delete")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rowData.type === 'carousel')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value, (item, inx) => {
            return (_openBlock(), _createBlock(AdvertisingItem, {
              key: item.id,
              data: item,
              "is-first": inx === 0,
              "is-last": inx === datas.value.length - 1,
              onChange: _cache[0] || (_cache[0] = () => _unref(init)())
            }, null, 8, ["data", "is-first", "is-last"]))
          }), 128)),
          _createElementVNode("div", {
            class: "advertising-add",
            onClick: _cache[1] || (_cache[1] = () => addDialogRef.value?.showDialog())
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Plus)
              ]),
              _: 1
            }),
            _createTextVNode(" 添加一条 ")
          ])
        ]))
      : (_ctx.rowData.type === 'distribute')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value, (item, inx) => {
                return (_openBlock(), _createBlock(AdvertisingItem, {
                  key: item.id,
                  data: item,
                  "is-first": inx === 0,
                  "is-last": inx === datas.value.length - 1,
                  onChange: _cache[2] || (_cache[2] = () => _unref(init)()),
                  "is-h": ""
                }, null, 8, ["data", "is-first", "is-last"]))
              }), 128)),
              _createElementVNode("div", {
                class: "advertising-add",
                onClick: _cache[3] || (_cache[3] = () => addDialogRef.value?.showDialog())
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                }),
                _createTextVNode(" 添加一条 ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.isFirst)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "up",
            onClick: _cache[4] || (_cache[4] = () => _unref(moveRow)('up'))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowUpBold)
              ]),
              _: 1
            }),
            _createTextVNode(" 上移 ")
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLast)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "down",
            onClick: _cache[5] || (_cache[5] = () => _unref(moveRow)('down'))
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowDownBold)
              ]),
              _: 1
            }),
            _createTextVNode(" 下移 ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "del",
        onClick: _cache[6] || (_cache[6] = () => _unref(delRow)())
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Delete)
          ]),
          _: 1
        }),
        _createTextVNode(" 删除 ")
      ])
    ]),
    _createVNode(_unref(JuouProForm), {
      ref_key: "addDialogRef",
      ref: addDialogRef,
      "is-dialog": true,
      title: "添加一条",
      items: items,
      onOk: _unref(handleAdd)
    }, null, 8, ["onOk"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})